// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageUploader_root__1Ik-l","imageBox":"ImageUploader_imageBox__jOPuI","remove":"ImageUploader_remove__Tl45A","upload":"ImageUploader_upload__3hD41"};